import gql from "graphql-tag";

export const GET_PRESIGNED_URL_UPLOAD = gql`
	query GetFilePresignedUrlUpload($fileName: String!) {
		filePresignedUrlUpload(fileName: $fileName)
		{
			key
			url
			contentType
		}
	}
`;
